import {
  updateRoleWithPermissions,
  getAllPermissions,
  getRoleByIdWithPermissions,
} from "../../../Redux/Users/UsersActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useNavigate, useParams } from "react-router";
import arrowIcon from "../../../Assets/arrowleft.png";
import makeAnimated from "react-select/animated";
import validator from "../../../Util/validator";
import styles from "./EditRole.module.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Select from "react-select";

const animatedComponents = makeAnimated();

function EditRole() {
  const { id } = useParams<{ id: string }>() ?? {};
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const {
    permissions,
    roleByIdWithPermissionsLoading,
    updateRoleWithPermissionsLoading,
  } = useSelector((state: RootState) => state.users);
  const [roleName, setRoleName] = useState("");
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  const [errors, setErrors] = useState<{
    roleName: string;
    selectedPermissions: string;
  }>({
    roleName: "",
    selectedPermissions: "",
  });

  const options: any = permissions?.map((permission: any) => ({
    label: permission.permissionName,
    value: permission.permissionId.toString(),
    data: permission,
  }));

  const updateRoleHandler = () => {
    const { isValid, errors: fieldErrors } = validator([
      {
        key: "roleName",
        value: roleName,
        type: "text",
      },
      {
        key: "selectedPermissions",
        value: selectedPermissions,
        type: "array",
      },
    ]);

    setErrors({ ...errors, ...fieldErrors });

    if (isValid && !updateRoleWithPermissionsLoading) {
      const successHandler = () => {
        navigate("/admin/roles", { replace: true });
      };

      dispatch(
        updateRoleWithPermissions({
          roleId: Number(id),
          roleName,
          permissionIds: selectedPermissions?.map(
            (permission: any) => permission?.data?.permissionId,
          ),
          successHandler,
        }),
      );
    }
  };

  useEffect(() => {
    dispatch(getAllPermissions());
    const successHandler = (data: any) => {
      setRoleName(data?.roleName);
      const selectedPermissionsData = data?.permissions?.map(
        (permission: any) => ({
          label: permission.permissionName,
          value: permission.permissionId.toString(),
          data: permission,
        }),
      );
      setSelectedPermissions(selectedPermissionsData);
    };
    const errorHandler = () => {
      navigate("/admin/roles", { replace: true });
    };
    dispatch(
      getRoleByIdWithPermissions({
        id: Number(id),
        successHandler,
        errorHandler,
      }),
    );
  }, [dispatch, id]);

  if (roleByIdWithPermissionsLoading) {
    return <Loading />;
  }

  return (
    <div className={styles.mainContainer}>
      <Link to="/admin/roles" replace className={styles.backButtonContainer}>
        <button className={styles.button}>
          <img src={arrowIcon} alt="arrowIcon" className={styles.arrowIcon} />
          Back to Roles
        </button>
      </Link>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Edit Role</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Role Name</p>
          <input
            type="text"
            className={styles.input}
            value={roleName}
            onChange={(e) => setRoleName(e.target.value)}
          />
          <p className={styles.error}>{errors.roleName}</p>
        </div>

        <div className={styles.inputContainer}>
          <Select
            className={styles.select}
            closeMenuOnSelect={false}
            components={animatedComponents}
            value={selectedPermissions}
            isMulti
            options={options ?? []}
            onChange={(e: any) => {
              setSelectedPermissions(e);
            }}
          />
          <p className={styles.error}>{errors.selectedPermissions}</p>
        </div>

        {updateRoleWithPermissionsLoading && <Loading />}

        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={updateRoleHandler}>
            Update Role
          </button>
        </div>
      </div>
    </div>
  );
}

export default EditRole;
